import axios from 'axios'
import moment from 'moment'

export const notifications = {
    state:{
        count: '',
        recentnotifications: [],
        notifications: []
    },
    mutations:{
      Count(state, data){
        state.count = data.data
      },  
      RecentNotifications(state, data){
        let recentnotify = data.data
        for(let i=0; i<recentnotify.length; i++){
            recentnotify[i].date_sent = moment(recentnotify[i].date_sent).fromNow()
        }
        state.recentnotifications = recentnotify

        },
      Notifications(state, data){
        let notify = data.data
        for(let i=0; i<notify.length; i++){
            notify[i].date_sent = moment(notify[i].date_sent).format('LT')
        }
        state.notifications = notify
      }

    },
    actions:{
    
      // =================Notifications management =============
      NotificationsCount: ({commit}) => {
        return new Promise((resolve, reject)=>{
          axios.get("/count/notifications")
          .then(({data, status})=>{
            if(status === 200){
              commit('Count', data)
              resolve(data);
            }
          })
          .catch((error)=>{
            reject(error);
          });
        })
      },

      Notifications: ({commit}) => {
        return new Promise((resolve, reject)=>{
          axios.get("/new/notifications")
          .then(({data, status})=>{
            if(status === 200){
              commit('RecentNotifications', data)
              resolve(data);
            }
          })
          .catch((error)=>{
            reject(error);
          });
        })
      },

      GetNotifications: ({commit}) => {
        return new Promise((resolve, reject)=>{
          axios.get("/notifications")
          .then(({data, status})=>{
            if(status === 200){
              commit('Notifications', data)
              resolve(data);
            }
          })
          .catch((error)=>{
            reject(error);
          });
        })
      },

      MarkNotifications: ({commit}) => {
        return new Promise((resolve, reject)=>{
          axios.put("/notifications")
          .then(({data, status})=>{
            if(status === 200){
              resolve(data);
              commit()
            }
          })
          .catch((error)=>{
            reject(error);
          });
        })
      },

      
  }
}